<template>
  <footer class="saction-footer">
    <slot></slot>
  </footer>
</template>

<script>
export default {
  name: "saction-footer"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.saction-footer {
  margin-top: 2em;
  padding-top: 2em;
  border-top: 1.5px solid #bebebe;
}
</style>
